import type { ScheduleMode } from './types';

// Single source of truth for mode-family checks. Funnel new
// `if (mode === '...')` branches through these helpers so that adding
// a future mode (e.g. bulk-manual) is a one-file edit, not a grep.

export const isSelfScheduleMode = (mode: ScheduleMode): boolean =>
  mode === 'self-schedule' ||
  mode === 'self-schedule-adhoc' ||
  mode === 'bulk-self-schedule';

export const isAdhocMode = (mode: ScheduleMode): boolean =>
  mode === 'adhoc' || mode === 'self-schedule-adhoc';

export const isManualMode = (mode: ScheduleMode): boolean =>
  mode === 'manual' || mode === 'adhoc';

/**
 * `true` only for the multi-candidate self-schedule entry from the
 * candidates table. Bulk piggybacks on `isSelfScheduleMode` for
 * step-shape and wizard rendering, but the save path, payload shape,
 * and prerequisite overlay are bulk-only — those branches gate on
 * this classifier.
 *
 * Implementation note: keep `isSelfScheduleMode` returning `true` for
 * bulk so we don't have to fork every existing self-schedule
 * conditional in `mapDetails` / `CalendarPanel` / etc. Bulk diverges
 * only where this classifier is checked explicitly.
 */
export const isBulkSelfScheduleMode = (mode: ScheduleMode): boolean =>
  mode === 'bulk-self-schedule';
